/**
 * Shared constants for artisan site templates.
 *
 * Neutral placeholders shown until the artisan replaces them with real photos
 * (AI image generation is currently disabled — see /sites/generate).
 * Values are intentionally identical to the ones historically used by
 * ArtisanTemplate.jsx so the "essential" template renders unchanged.
 */
export const NEUTRAL_HERO_IMAGE =
  "https://img.freepik.com/vecteurs-premium/illustration-ouvriers-du-batiment-construisent_961875-4945.jpg";

export const NEUTRAL_SERVICE_IMAGE =
  "https://mass-btp-paris.hustart.fr/api/api/uploads/site-service/03fe65f0-4bbb-4ac3-b41c-3762fd166473/bbd00ff1-35c7-4641-babd-43af00c1d7be.png";

/** Default label used when no activity filter is active. */
export const ALL_ACTIVITIES_LABEL = "Toutes";
